import { Card } from "antd";

import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { InterventionSectionForm } from "@/modules/intervention/intervention-section-form";
import InterventionSectionRecommendation from "@/modules/intervention/intervention-section-recommendation";
import InterventionSectionTabs from "@/modules/intervention/intervention-section-tabs";

import InterventionSectionCardExtra from "./intervention-section-card-extra";
import InterventionSectionCardGrid from "./intervention-section-card-grid";
import InterventionSectionCardHeader from "./intervention-section-card-header";

import "./intervention-section-card.style.less";

const InterventionSectionCard = () => {
  const { menuQuery } = useInterventionSectionContext();

  return (
    <Card
      title={<InterventionSectionCardHeader />}
      loading={menuQuery.isLoading}
      extra={<InterventionSectionCardExtra />}
      classNames={{
        root: "intervention-section-card",
        header: "intervention-section-card--header",
        title: "intervention-section-card--title",
        extra: "intervention-section-card--extra",
        body: "intervention-section-card--body",
      }}
    >
      <InterventionSectionCardGrid
        forms={<InterventionSectionForm />}
        recommendation={<InterventionSectionRecommendation />}
        tabs={<InterventionSectionTabs />}
      />
    </Card>
  );
};

export default InterventionSectionCard;
